.input {
  width: 100%;

  textarea, textarea:hover {
    background-color: var(--bc-color-fill-secondary);

    &:focus {
      background-color: var(--bc-color-fill-secondary);
    }
  }
}
